// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "545") return "vendors.845edf0a8b9b7560.js";
  // return url for filenames based on template
  return "" + chunkId + ".chunk.bundle.js"
}